export const FETCH_ENGAGEMENT_SUMMARY = 'FETCH_ENGAGEMENT_SUMMARY'
export const SERVER_RESOURCE = '/engagement-summary'
export const CHANGE_COMMUNITY = 'CHANGE_COMMUNITY'
export const DEFINE_COMMUNITY = 'DEFINE_COMMUNITY'

export const GENERAL = 'general'
export const DOMAIN = 'domain'

export const CHANGE_TIME_SPAN = 'CHANGE_TIME_SPAN'

export const YESTERDAY = {
  description: 'Yesterday',
  key: 'time',
  value: 'now-1d/d',
}
export const ONE_WEEK = {
  description: 'Last week',
  key: 'time',
  value: 'now-1w/w',
}
export const FOUR_WEEKS = {
  description: 'Last four weeks',
  key: 'time',
  value: 'now-4w/w',
}

export const timeFilters =  [YESTERDAY, ONE_WEEK, FOUR_WEEKS]



// WEBPACK FOOTER //
// ./src/pages/engagement-summary/constants.ts